import { type } from "@testing-library/user-event/dist/type";

export const ApiEndpoints = {
    Login: {
        Authenticate: `User/Authenticate`,
    },
    User:{
        CreateUser: `User/UserCreation`,
        FetchUserList: (page, limit, search) =>
            `User/FetchUserListing?page=${page}&limit=${limit}&search=${search}`,
        FetchUser: `User/FetchUserListing`,
        FetchLeadUsers:`User/FetchLeadUsers`,
        FetchLeadUserswithSearch:(Search)=>`User/FetchLeadUsers?search=${Search}`,
        FetchLeadUserMapping:(LeadId)=>`User/FetchLeadUserMapping?LeadUserId=${LeadId}`,
        LeadUserMapping:(LeadId)=>
            `User/LeadUserMapping?LeadId=${LeadId}`,
        EditUser:(UserId)=>`User/EditUsers?UserId=${UserId}`,
        DeleteUser:(UserId)=>`User/DeleteUser?UserId=${UserId}`,
        UpdatePassword: `User/UpdatePassword`,
    },
    Entity:{
        CreateClient: `Entity/CreateClient`,
        FetchClient: `Entity/FetchClient`,
        FetchProject: `Entity/FetchProject`,
        FetchUserWithRole: `User/FetchUserWithRole`,
        FetchTimeZone:`Entity/FetchTimeZone`,
        CreateProject:`Entity/CreateProject`,
        FetchCategory:`Entity/FetchCategory`,
        FetchProjectByClient:(clientId)=> `Entity/FetchProjectByClient?ClientId=${clientId}`,
        FetchProjectWithParams:(type,search) => `Entity/FetchProject?usage=${type}&Search=${search}`,
        FetchclientList: (page, limit, search) =>
            `Entity/FetchClientDetails?page=${page}&limit=${limit}&search=${search}`,
        FetchProjectList: (page, limit, search) =>
            `Entity/FetchProjectListing?page=${page}&limit=${limit}&search=${search}`,
        GetClientDetails: (clientId) =>
            `Entity/GetClientDetails?ClientId=${clientId}`,
        FetchProjectDetails: (projectId) =>
            `Entity/FetchProjectDetails?ProjectId=${projectId}`,
        GetProjectDetails: (projectId) =>
            `Entity/GetProject?ProjectId=${projectId}`,
        FetchProjectMapping:(ProjectId) =>
            `Entity/FetchProjectMapping?ProjectId=${ProjectId}`,
        ProjectUserMapping:(ProjectId)=>
            `Entity/ProjectUserMapping?ProjectId=${ProjectId}`,
        FetchProjectByUser:(UserId)=>
            `Entity/FetchProjectByUser?UserId=${UserId}`,
        DownloadReport:(UserId,ProjectId,TeamUserId,Year,Month,type,IsConvertTime)=>
            `Entity/FetchReport?UserId=${UserId}&ProjectId=${ProjectId}&TeamUserId=${TeamUserId}&Year=${Year}&Month=${Month}&type=${type}&ConvertTime=${IsConvertTime}`,
    },
    TimeSheet :{
        CreateTimeEntry:`TimeSheet/CreateTimeEntry`,
        DailyTotalHours:(UserId,selectedDate)=>`TimeSheet/DailyTotalHours?UserId=${UserId}&selectedDate=${selectedDate}`,
        TotalHours:(UserId,Month,Week,ProjectId,CategoryId,clientId)=>`TimeSheet/TotalHours?UserId=${UserId}&Week=${Week}&Month=${Month}&ProjectId=${ProjectId}&CategoryId=${CategoryId}&clientId=${clientId}`,
        TableHours:(UserId)=>`TimeSheet/TableHours?UserId=${UserId}`,
        EditTimeSheet:(TimesheetId)=>`TimeSheet/EditTimeSheet?TimesheetId=${TimesheetId}`,
        DeleteTimeEntry:(TimesheetId)=>`TimeSheet/DeleteTimeEntry?TimesheetId=${TimesheetId}`,
        FetchDailyTimeEntry:(userId,page,limit,TimeSheetDate) =>
            `TimeSheet/FetchDailyTimeEntry?userId=${userId}&page=${page}&limit=${limit}&TimeSheetDate=${TimeSheetDate}`,
        FetchTimeEntry:(userId,page,limit) =>
            `TimeSheet/FetchTimeEntry?userId=${userId}&page=${page}&limit=${limit}`,
        FetchTimeEntryWeek:(userId,page,limit,Week,projectId,CategoryId,clientId) =>
            `TimeSheet/FetchTimeEntry?userId=${userId}&page=${page}&limit=${limit}&week=${Week}&projectId=${projectId}&CategoryId=${CategoryId}&clientId=${clientId}`,
         FetchTimeEntryMonth:(userId,page,limit,monthrange,projectId,CategoryId,clientId) =>
            `TimeSheet/FetchTimeEntry?userId=${userId}&page=${page}&limit=${limit}&Month=${monthrange}&projectId=${projectId}&CategoryId=${CategoryId}&clientId=${clientId}`,
         FetchImportedFiles:(userId,page,limit) =>
            `TimeSheet/FetchImportedFiles?userId=${userId}&page=${page}&limit=${limit}`,
         ImportFile:(userId)=>
            `TimeSheet/ImportFile?userId=${userId}`,
   
        }
}

export const ApiEndpointMethod = {
    Post: 'POST',
    Get: 'GET',
    Put: 'PUT',
    Delete: 'DELETE'
};